// Binary entrypoint. All logic lives in run.ts so tests can import it without
// executing the CLI as a side effect.
import { main } from './run.js';

process.exitCode = await main();
